export const loadCartFromLocalStorage = <T>(key: string): T | null => {
	try {
		const data = localStorage.getItem(key)
		return data ? JSON.parse(data) : null
	} catch (err) {
		console.error('Error loading from localStorage', err)
		return null
	}
}

export const saveCartToLocalStorage = (key: string, value: unknown) => {
	try {
		localStorage.setItem(key, JSON.stringify(value))
	} catch (err) {
		console.error('Error saving to localStorage', err)
	}
}

export const clearAppliedCoupon = () => {
	try {
		localStorage.removeItem("appliedCoupon");
		localStorage.removeItem("appliedCouponCode");
		localStorage.removeItem("selectedCoupon");
	} catch (err) {
		console.error("Error clearing applied coupon", err);
	}
};


